import React from 'react'
import Card from './Card'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import pepper from "../ASSESTS/Food/pepper.jpg"
import tomato from "../ASSESTS/Food/tomato2.jpg"
import gizzard from "../ASSESTS/Food/gizzard.jpg"
import catfish from "../ASSESTS/Food/catfish.png"
const BestProducts = () => {
  return (
    <div>
        <Container>
            <TextHold>
                <p>Best Products</p>
                <h1>Featured Collection
</h1>
            </TextHold>
         <Wrapper>
         <Card image={pepper} price='3,000' title='Pepper' />
            <Card image={catfish} price='5,500' title='catfish' />
            <Card image={tomato} price='1,600' title='Tomatoes' />
            <Card image={gizzard} price='4,000' title='Chicken gizzard' />
         </Wrapper>

         <ButtonHold>
            <Button to="/product" >All Products</Button>
         </ButtonHold>
          
        </Container>
    </div>
  )
}

export default BestProducts

const Button = styled(Link)`
  width: 150px;
  height: 50px;
  background-color: black;
  color: white;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
text-decoration: none;
:hover{
  transition: all 350ms ease-in-out;
  transform: scale(0.99);
  background-color: #90ee909c;
  color: black;
}
 
`;

const ButtonHold = styled.div`
width: 100%;
display: flex;
justify-content: center;
align-items: center;
padding-bottom: 30px;
`

const TextHold = styled.div`
  display: flex;
  /* justify-content: center; */
  align-items: center;
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items:center;
  text-align: center;
  width: 100%;
  z-index: 11;
    color: black;


  p{
    font-size: 20px;
  display: flex;
  justify-content: center;
  align-items:center;
  text-align: center;
  width: 100%;
  margin-bottom: 30px;
  z-index: 1111;

  @media screen and (max-width: 768px) {
    font-size: 16px;
    
  
  }
  }

  h1{
    font-size: 50px;
  font-weight: bold;
  margin-bottom: 30px;
  display: flex;
  justify-content: center;
  align-items:center;
  text-align: center;
  width: 100%;
  @media screen and (max-width: 768px) {
    font-size: 35px;
    
  
  }
  }
`;


const Wrapper = styled.div`
display: flex;
justify-content: center;
align-items: center;
width: 100%;
flex-wrap: wrap;

@media screen and (max-width: 768px) {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    justify-content: center;
  align-items: center;
    /* margin-top: 50px; */
    /* background-color: #e3ffe6; */
    
  
  }
`

const Container = styled.div`
    width: 100%;
    /* background-color: #79171d; */

`